export default {
  'Submit': 'Abschicken',
  'Save': 'Speichern',
  'enterOTP': 'Bestätigen Sie Ihre Telefonnummer',
  'otpSent': 'Einmaliges Passwort gesendet',
  'login/signup': 'Anmelden / Registrieren',
  'resendCode': 'Code erneut senden',
  'edit': 'Bearbeiten',
  'otpMessage': 'Ein 6-stelliger Code wurde an Ihre Handynummer gesendet',
  'oyo360WelcomeMessage': 'Willkommen bei OYO',
  'oyo360ResendCode': 'Code erneut senden',
  'oyo360Edit': 'Bearbeiten',
  'oyo360otpMessage': 'Geben Sie den Code ein, den wir über SMS an Ihre Handynummer gesendet haben',
  'buttonActionContinue': 'Fortfahren',
  'chooseLanguage': 'Wählen Sie eine Sprache',
  'currentLanguage': 'AKTUELLE SPRACHE',
  'otherLanguages': 'ANDERE SPRACHEN',
  'google': 'Mit Google anmelden',
  'facebook': 'Mit Facebook anmelden',
  'or': 'oder',
  'buttonActionSubmit': 'Senden',
  'welcomeTitle': 'Willkommen bei OYO',
  'welcomeHeadingForMailLogin': 'Bitte geben Sie die bei uns gespeicherte E-Mail-Adresse ein',
  'welcomeHeadingForPhoneLogin': 'Bitte geben Sie die bei uns gespeicherte Handynummer ein',
  'emailIdLabel': 'E-Mail-Adresse',
  'phoneNumberLabel': 'Telefonnummer',
  'passwordLabel': 'Passwort',
  'newPasswordLabel': 'Neues Passwort',
  'confirmNewPasswordLabel': 'Neues Passwort bestätigen',
  'emailErrorMessage': 'Bitte geben Sie die richtige E-Mail-Adresse ein',
  'phoneNumberErrorMessage': 'Bitte geben Sie die richtige Telefonnummer ein',
  'passwordErrorMessage': 'Bitte geben Sie das richtige Passwort ein',
  'confirmPasswordErrorMessage': 'Passwort stimmt nicht überein!',
  'generateNewPassword': 'Ein neues Passwort erstellen',
  'loginButtonLabel': 'Anmelden',
  'loginWithPhoneButtonLabel': 'Fortfahren mit Telefon',
  'loginWithOtp': 'Mit vorläufigem Passwort anmelden',
  'loginWithEmailButtonLabel': 'Fortfahren mit E-Mail-Adresse',
  'back': 'Zurück',
  'loginWithOtpTitle': 'Verifizierungscode eingeben',
  'loginWithOtpHeading': 'Ein 6-stelliger Code wurde an Ihre Handynummer gesendet',
  'listYourProperty': 'Veröffentlichen Sie Ihre Unterkunft',
  'privacyPolicy': 'Datenschutzbestimmungen',
  'verifyEmail': 'E-Mail-Adresse verifizieren',
  'verifyMobile': 'Handynummer verifizieren',
  'forgotPasswordPhoneSubHeading': 'Wir senden Ihnen einen 6-stelligen Code zur Verifizierung Ihrer Telefonnummer',
  'forgotPasswordMailSubHeading': 'Wir senden Ihnen einen 6-stelligen Code zur Verifizierung Ihrer E-Mail-Adresse',
  'newPasswordCondition1': 'Muss sowohl eine Zahl als auch ein Sonderzeichen enthalten',
  'newPasswordCondition2': 'Muss aus mindestens 8 Zeichen bestehen',
  'newPasswordCondition3': 'Muss sowohl Groß- als auch Kleinbuchstaben enthalten',
  'confirmLogin': 'Bestätigen und Anmelden',
  'getOTP': 'Vorläufiges Passwort anfordern',
  'invalidInput': 'Ungültige Eingabe',
  'passwordResetMessage': 'Passwort erfolgreich erstellt',
  'otpErrorMessage': 'Bitte geben Sie das richtige vorläufige Passwort ein',
  'resendOtpSuccessMessage': 'Ein weiteres vorläufiges Passwort wurde an Ihre Handynummer gesendet',
  'InternalServerErrorMessage': 'Interner Serverfehler',
  'resetPasswordHeading': 'Ein 6-stelliger Code wurde an Ihre E-Mail-Adresse und Handynummer gesendet',
  'signingIn': 'Anmelden',
  'invalidMobileNumber': 'Ungültige Handynummer',
  'privacyFooterText': 'Indem Sie sich in das Konto einloggen, stimmen Sie unseren{termsOfUse} und {privacyPolicy} zu',
  'and': 'und',
  'termsOfUse': 'Nutzungsbedingungen',
  'listProperty': 'Eigenschaft auflisten',
  'whiteSpace': ' ',
  'errorNoAssociatedHotels': 'Keine zugeordneten Hotels vorhanden',
  'facingIssue': 'Facing any issue? ',
  'oldLoginViewSwitch': 'Switch to Old view',
  'mobileNumberPlaceholder': 'Telefonnummer eingeben',
  'loginSubText': 'Bitte geben Sie Ihre Telefonnummer ein, um in nur 30 Minuten ein Belvilla-Ferienhaus zu werden',
  'termsOfService': 'Nutzungsbedingungen',
  'termsOfServiceFooter': 'Indem ich unten Weiter auswähle, stimme ich den folgenden {termsOfService} zu',
  'secureInformation': 'Keine Sorge, Ihre Daten sind bei uns sicher',
  'mobileSearchPlaceholder': 'Suche',
  'passwordChangeInformationText': 'Nach der Änderung Ihres Passworts werden Sie von allen Geräten abgemeldet.'
};
